import React, { PropsWithChildren } from 'react';

import { useGetPracticeSettings } from 'store/settings/selectors';

export const PrivacyPolicyLink = ({ children }: PropsWithChildren) => {
  const { privacyPolicyUrl } = useGetPracticeSettings();

  return (
    <a target="_blank" rel="noopener noreferrer" href={privacyPolicyUrl}>
      {children}
    </a>
  );
};
